import {
  Button,
  Grid,
  Link,
  TextField,
  Typography,
  CircularProgress,
  Divider,
  IconButton,
} from "@material-ui/core";
import { Alert, Skeleton } from "@material-ui/lab";
import { makeStyles, withStyles } from "@material-ui/core";
import React, { useState, useEffect,useRef } from "react";
import { useSelector,useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { store, history } from "../../../../../helpers";
import { loginService } from "../model/login-service";
import { commonService } from "../../../../../services/common.service";
import { routePaths } from "../../../../config/route-paths";
import EQuickPay from "../../e_quick-pay/view/_quick-pay";
import EForgot_Password from "../../e_forgot-password/e_forgot-password";
import Countdown from "react-countdown-now";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import Switch from '@material-ui/core/Switch';
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
// import ERegister from "../../e_register/view/_register";
import EsignUpVerification from "../../../e_register/e_register";
import ESendOtp from "../../e_send-otp/view/_send-otp";
import NewConnection from "../../e_new-connection/view/_new-connection";
import ERegisterSuccess from "../../../e_Succes-section/e_register_success";
import TrackingNewConnection from "../../e_tracking-new-connecton/_tracking_new-connection";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import {useLocation} from "react-router-dom";

import { loginApiLoading } from "../../../model/action";
import { emit } from "process";
import { config } from "../../../../../enviroment";


import InputAdornment from "@material-ui/core/InputAdornment";
import { Visibility, VisibilityOff } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  loginLabel: {
    color: theme.palette.ePrimary.base + "!important",
    fontWeight: "bold",
    marginBottom: "6%",
  },
  errorSpace: {
    padding: "2%",
  },
  zeroMargin: {
    margin: "0 !important"
  },
  inputLabelField: {
    padding: 0,
  },
  inpField: {
    width: "70%",
    alignSelf: "center"
  },
  mobileInpField: {
    width: "90% !important"
  },
  mobileinpGrid: {
    textAlign: "end",
  },
  loginSubmitBtn: {
    "&:hover": {
      backgroundColor: theme.palette.eSecondary.hover,
    },
    backgroundColor: theme.palette.eSecondary.base,
    width: "80%",
    height: "40px",
    borderRadius: 28,
    color: theme.palette.eWhite.base,
  },
  linkColor: {
    color: theme.palette.ePrimary.base,
  },
  btnContainer: {
    ["@media (min-width:671px) and (max-width:996px)"]:  {
      width: "auto",
    },
    width: "100%",
    marginTop: "auto",
  },
  otpBtn: {
    "&:hover": {
      color: theme.palette.eTertiary.hover,
    },
    fontSize: "0.75rem",
    color: theme.palette.eTertiary.base,
    backgroundColor: "transparent",
    margin: "auto",
    border: "none",
    cursor: "pointer",
    textDecoration: "underline !important",
    display: "inline",
    padding: 0,
    lineHeight: 1,
  },
  registerBtn: {
    "&:hover": {
      color: theme.palette.ePrimary.hover,
    },
    borderRadius: 29,
    color: theme.palette.ePrimary.base,
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    textDecoration: "underline !important",
    display: "inline",
    fontSize: "0.75rem",
  },
  circularProgressColor: {
    color: theme.palette.eWhite.base,
  },
  loadingCursor: {
    cursor: "progress",
  },
  dividerColor: {
    backgroundColor: theme.palette.eLight.base,
  },
  forgotPasswordBtn: {
    fontSize: "0.75rem",
    color: theme.palette.ePrimary.base,
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    textDecoration: "underline !important",
    display: "flex",
    padding: 0,
    lineHeight: 1,
    marginRight: "15%",
    justifyContent:"flex-end",
    marginBottom: "2%",
  },
  alertMessage: {
    // margin: "0% 14%",
    padding: "0% 1%",
    color: theme.palette.eDanger.dark,
    backgroundColor: theme.palette.eDanger.light,
    fontSize: "0.68rem",
    justifyContent: "center",
  },
  mobileNumberError: {
    fontSize: "0.75em",
    color: theme.palette.eDanger?.dark + "!important",
    textAlign: "left",
  },
  pd3: {
    padding: "1% auto !important",
    width: "-webkit-fill-available",
  },
  mr1: {
    [theme.breakpoints.down("sm")]: {
      marginRight: "2%",
    },
  },
  pdY5: {
    background: theme.palette.eFaint.hover,
    margin: 0,
    width: "initial",
  },
  textColor: {
    color: theme.palette.text.primary,
    lineHeight: 1,
  },
  alignuserName: {
    textAlign: "start",
    marginLeft: "15%",
  },
  marginContain: {
    marginTop: "1%",
  },
  
  secondaryColor: {
    color: theme.palette.ePrimary.base + " !important",
    marginTop:'0.2rem',
    padding: 2,
    '& .MuiSvgIcon-root': {
      fontSize: 17,
    },
  },
  radioLabel: {
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
  },
  mobileRadio: {
    marginLeft: -2,
    marginRight: 5,
  },
  toggle: {
    '&.MuiSwitch-root': {
      width: "60px",
      height: "24px",
      padding: "0px",
      marginRight: "8px",
    },
    '& .MuiIconButton-root': {
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    '& .MuiSwitch-switchBase': {
      color: "#ffffff",
      padding: "3px",
    },
    '& .MuiSwitch-track': {
      backgroundColor: "#818181",
      borderRadius: "20px",
      opacity: "1",
      "&:after, &:before": {
        color: "white",
        fontSize: "12px",
        position: "absolute",
        top: "3px"
      },
      "&:before": {
        content: "'NO'",
        right: "13px"
      }
    },
    '& .Mui-checked': {
        color: '#ffffff',
        transform:'translateX(36px) !important',
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: "transparent",
        },
      },
      '& .MuiSwitch-thumb': {
        width: "18px",
        height: "18px",
      },
      '& .Mui-checked + .MuiSwitch-track': {
        backgroundColor:'#44AD85',
        opacity: "1",
        "&:after": {
          content: "'YES'",
          left: "13px"
        },
        "&:before": {
          content: "''",
        }
      },
  },
  iconstyle: {
    fontSize: "1.5rem" ,
    marginBottom:'0.5rem'
  },
  passwordEyeIcon: {
    color: theme.palette.ePrimary.base,
    //fontSize: "1rem" ,
  },
  supportNumber:{
    borderRadius: 29,
    color: theme.palette.ePrimary.base,
    backgroundColor: "transparent",
    border: "none",
    display: "inline",
    fontSize: "0.75rem",
    display:'flex',
    justifyContent:'center',
    alignItems:'center'
  },
  mobileExt:{
    textAlign:'center'
  }
}));
export const CssTextField = withStyles((theme) => ({
  root: {
    "& label": {
      width: "100%",
      textAlign: "center",
      transformOrigin: "center",
      color: theme.palette.eRich.base, 
    },
    "& .MuiInputBase-root": {
      fontSize: "0.875rem",
    },
    "& .MuiInputBase-input": {
      padding: "0.2rem 0rem",
    },
    "& .Mui-error": {
      color: theme.palette.eDanger?.dark,
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.eDanger?.dark,
    },
    "& ::placeholder": {
      color: theme.palette.eDark?.base,
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: theme.palette.eDanger?.dark,
    },
    "& .MuiFormHelperText-root": {
      lineHeight: 1 + !"important",
      margin: "0.1rem",
    },
  },
}))(TextField);
function ELogin() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 550px)" });
  const MOBILE_RADIO = "MOBILE";
  const CUSTOMER_RADIO='CUSTOMER'
  const EMAIL_RADIO = "EMAIL";
  const [userNameType,setuserNameType] = useState(CUSTOMER_RADIO);
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [customerNum,setCustomerNum]=useState()
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [userNameFieldError, setUserNameFieldError] = useState(false);
  const [userNameRequire, setUserNameRequire] = useState(false);
  const [userNameError, setUserNameError] = useState(false);
  const [emailRequire, setEmailRequire] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [mobileRequire, setMobileRequire] = useState(false);
  const [mobileError, setMobileError] = useState(false);
  const [cNoError, setcNoError] = useState(false);
  const [cNoRequire, setcNoRequire] = useState(false);
  const [passwordRequire, setPasswordRequire] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [loginErrorMessage, setLoginErrorMessage] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [countdownerror, setCountdownerror] = useState(false);
  const [timeCountdown, setTimeCountdown] = useState();
  const [quickPayShow, setQuickPayShow] = useState(true);
  const [loginShow, setLoginShow] = useState(true);
  const [loginOtpShow, setLoginOtpShow] = useState(false);
  const [registerShow, setRegisteShow] = useState(false);
  const [forgotPasswordShow, setForgotPasswordShow] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [usernametype,setUserNameType]=useState()

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const lockDurationDefault = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.LOCK_DURATION
  );
  let country_Calling_Code_backend =
  useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_MOBILE_NUMBER_EXTENSION_BACKEND
  );
  const country_Calling_Code = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_PHONE_NUMBER_EXTENSION);
  const mobileLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_MOBILE_LENGTH);
  const minLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_MIN_CN_LENGTH);
  const digitsRegex = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_DIGITS_REGEX);
  const emailRegex = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_EMAIL_REGEX);
  const supportNumber = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_SUPPORT_NUMBER);
  const { t: loginLabels, ready: loginLabelReady } = useTranslation("label-E_AUTH_LOGIN");
  const { t: forgotPasswordLabel, ready: forgotPwdLR } = useTranslation(
    "label-E_AUTH_FORGOT_PASSWORD"
  );
  const { t: loginOtpLabel, ready: loginOtpLR } = useTranslation("label-E_AUTH_LOGIN_OTP");
  const { t: registerLabel, ready: registerLR } = useTranslation("label-E_AUTH_REGISTER");
  const { t: serverExceptionLabel, ready: serverExcepLR } = useTranslation(
    "label-E_SERVER_EXCEPTIONS"
  );

  const [checked, setChecked] = useState(false);

  const search = useLocation().search.slice(12);
  useEffect(()=>{
    if(search && search===config.urls.AUTH_TOKEN){
      history.push({
        pathname: routePaths.MIGRATE_USER,
        state: { param:search },
      });
    }
  },[search])

  const switchHandler = (event) => {
    setChecked(event.target.checked);
    if(event.target.checked === true) {
      i18next.changeLanguage("bn");
    } else {
      i18next.changeLanguage("en");
    }
  };

  let handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "userName" && userNameType === MOBILE_RADIO) {
      setMobileError(false)
      setMobileRequire(false)
      setMobile(value);
      var digitsRegexS = new RegExp(digitsRegex);
      if (value === "" || digitsRegexS.test(value)) {
       setMobile(value);
      }
    } else if (name === "userName" && userNameType === CUSTOMER_RADIO) {
       setcNoError(false)
       setcNoRequire(false)
      if(value.length<=mobileLength){
        setCustomerNum(value)
        setUserNameType(CUSTOMER_RADIO)
      }
    }
    else if (name === "password") {
      setPassword(value);
    }
    else if (name === "userNameType") {
      setuserNameType(value);
    }
  };

  let emailBlur = () => {
    if (email) {
      setEmailError(false);
      setEmailRequire(false);
      var emailRegExp = new RegExp(emailRegex);
      if (emailRegExp.test(email)) {
        setEmailError(false);
      } else {
        setEmailError(true);
      }
    } else {
      setEmailRequire(true);
    }
  }
  let mobileBlur = () => {
    if (mobile) {
      setMobileError(false);
      setMobileRequire(false);
      var mobileRegex = store.getState().parametersWidgets.ParameterLookup.E_APPLICANT_MOBILE_REGEX;
      var mobileRegExp = new RegExp(mobileRegex);
      var mobileTest = mobileRegExp.test(mobile);
      if ( mobileTest&& (mobile.length < mobileLength) ) {
        setMobileError(true);
      } else {
        setMobileError(false);
      }
    } else {
      setMobileRequire(true);
    }
  }
  let customerNumberBlur = () => {
    if (customerNum) {
      setcNoError(false);
       setcNoRequire(false);
      if (customerNum.length <= mobileLength && customerNum.length >=minLength ) {
        setcNoError(false);
      } else {
        setcNoError(true);
      }
    } else {
      setcNoRequire(true);
    }
  }
  let userNameBlur = () => {
    if (store.getState().parametersWidgets.ParameterLookup) {
      // needto change to useSelector
      if (userName) {
        setUserNameRequire(false);
        setUserNameError(false);

        var emailRegex =
          store.getState().parametersWidgets.ParameterLookup.EMAIL_REGEX;

        var emailRegExp = new RegExp(
          "^([a-z0-9\\+_\\-]+)(\\.[a-z0-9\\+_\\-]+)*@([a-z0-9\\-]+\\.)+[a-z]{2,6}$"
        );
        var emailTest = emailRegExp.test(userName);
        var mobileRegex = store.getState().parametersWidgets.ParameterLookup.E_APPLICANT_MOBILE_REGEX;
        var mobileRegExp = new RegExp(mobileRegex);
        var mobileTest = mobileRegExp.test(userName);
        if (emailTest || (mobileTest && userName.length == mobileLength)) {
          setUserNameError(false);
        } else {
          setUserNameError(true);
        }
      } else {
        setUserNameRequire(true);
        setUserNameError(false);
      }
    }
  };

  let passwordBlur = () => {
    if (store.getState().parametersWidgets.ParameterLookup) {
      if (password) {
        setPasswordRequire(false);
        setPasswordError(false);
      } else {
        setPasswordRequire(true);
        setPasswordError(false);
      }
    }
  };

  let showLogin = () => {
    setLoginShow(true);

    setQuickPayShow(true);

    setRegisteShow(false);

    setForgotPasswordShow(false);

    setLoginOtpShow(false);
  };

  let loginSubmit = (e) => {
    e.preventDefault();
    setLoginError(false);
    let userNameValue = "";
    if (userNameType === MOBILE_RADIO) {
      mobileBlur();
      if (mobileError || mobileRequire) {
        return;
      } else {
        userNameValue = mobile.startsWith(country_Calling_Code_backend)?mobile:country_Calling_Code_backend+mobile;
      }
    } else {
      customerNumberBlur();
      if (cNoError || cNoRequire) {
        return;
      } else {
        userNameValue = customerNum;
      }
    }
    passwordBlur();
    if (userNameValue && password && !passwordRequire && !passwordError ) {
      setLoading(true);
      dispatch(loginApiLoading(true))
      loginService
        .login(userNameValue, password)
        .then((response) => {
          if (response.acessToken) {
            let popup = localStorage.getItem("popup");
            let banner = localStorage.getItem("banner");
            localStorage.clear();
            localStorage.setItem("popup", popup);
            localStorage.setItem("banner", banner);
            localStorage.setItem("firstLogin",true);
            localStorage.setItem(
              "bearer",
              commonService.encodeString(JSON.stringify(response))
            );
            commonService.gotoMainApp();
          } else if (response.lastFourDigitsOfPhoneNumber) {
            if (response.otpVerified !== "true") {
              history.push({
                pathname: routePaths.SIGN_UP_VERIFY_OTP,
                state: {
                  path: routePaths.LOGIN,
                  userName: userNameValue,
                  mobile: "",
                  password: password,
                },
              });
              localStorage.removeItem("flowType");
              localStorage.setItem("flowType", "LOGIN_OTPVERIFIED");
            } else {
              localStorage.removeItem("flowType");
              localStorage.setItem("flowType", "LOGIN");
              history.push({pathname: routePaths.ACTIVATE_EMAIL, state: { path: routePaths.SIGN_UP_VERIFY_OTP }})
            }
          }
          setLoading(false);
          setLoginError(false);
          dispatch(loginApiLoading(false))

        })
        .catch((error) => {
          dispatch(loginApiLoading(false))
          if (error.response && error.response.data.statusCode === 403) {
            setLoginError(true);
            if(error.response.data.message === "INACTIVE_SA"){
              setLoginErrorMessage( loginLabelReady ? "E_INACTIVESA_ERROR" :"");
              setLoading(false);
              return;
            }
            setCountdownerror(true);
            setLoading(false);
            if (error.response.data.message === "E_LOGIN_USER_BLOCKED") {
              setTimeCountdown(Date.now() - 1000 + 60000 * lockDurationDefault);
            } else {
              setTimeCountdown(
                Date.now() - 1000 + 60000 * error.response.data.message
              );
            }
          } else if (error.response) {
            let count=0;
            if(error.response.data.statusCode === 401 && error.response.data.message.includes('|')){
              let message=error.response.data.message.split('|')
              setLoginError(true);
              if(message[1] === "E_LOGIN_INVALID_ATTEMPTS"){
                if(message[0]>1){
                  count=1;
                }
                setLoginErrorMessage(count==1?loginLabelReady?loginLabels("E_LOGIN_INVALID_ATTEMPTS").replace("*",message[0]):"":loginLabelReady?loginLabels("E_LOGIN_INVALID_ATTEMPT").replace("*",message[0]):"");
                setLoading(false);
                return;
              }
            }
            if (
              error.response.data.statusCode === 500 ||
              error.response.status === 404 || error.response.status === 400
            ) {
              setLoginError(true);
              if( error.response.data.message?.includes("Customer number or username entered by you is not in our records") || error.response.data.message === "USERNAME_NOT_FOUND"){
                setLoginErrorMessage(loginLabelReady ? loginLabels("E_USERNAME_NOT_FOUND") :"");
                setLoading(false);
                return;
              }
              if(error.response.data.message === "DIDNOT_REGISTER"){
                setLoginErrorMessage(loginLabelReady ? loginLabels("DIDNOT_REGISTER") :"");
                setLoading(false);
                return;
              }
             
              setLoginErrorMessage(
                serverExcepLR?serverExceptionLabel("E_SERVER_EXCEPTIONS_NOT_RIGHT") : ''
              );
              setLoading(false);
            } else {
              setLoginError(true);
              error.response.data.error_description ? setLoginErrorMessage(error.response.data.error_description):setLoginErrorMessage(error.response.data.message);
              setLoading(false);
            }
          }
      });
    }
  };

  const ref=useRef(null);

  const pasteHandler=(e)=>{
    e.preventDefault()
  }

  const contextMenuHandler = (e) => {
    e.preventDefault();
  }

  useEffect(()=>{
    const element=ref.current
    element.addEventListener("contextmenu", contextMenuHandler,{capture:true});
    return () =>{
      element.removeEventListener("contextmenu", contextMenuHandler,{capture:true});
    } 
  },[])

  const inputStyle = { transitionDelay: "9999s", textAlign: "center" };
  let keypress = (event) => {
    const { name } = event.target;
    if (name === "userName") {
      setUserNameRequire(false);
      setUserNameError(false);
    }
    if (name === "password") {
      setPasswordRequire(false);
      setPasswordError(false);
    }

    if (event.key === "Enter") {
      loginSubmit(event);
    }
  };
  
  let loginOtpClick = (e) => {
    history.push(routePaths?.LOGIN_VIA_OTP);
  };

  let registerClick = (e) => {
    history.push(routePaths?.REGISTER);
  };

  let forgotPasswordClick = (e) => {
    history.push(routePaths?.FORGOT_PASSWORD);
  };
  function countDown({ minutes, completed }) {
    let newAfter = loginLabels("E_USER_BLOCKED").replace("***", minutes + 1);
    if (completed) {
      setLoginError(false);
      setCountdownerror(false);
      return (
        <div>
          <span></span>
        </div>
      );
    } else {
      return (
        <div>
          <React.Fragment>
            <Alert
              className={classes.alertMessage}
              severity="error"
              icon={false}
            >
              <Typography
                variant="caption"
                align="center"
                dangerouslySetInnerHTML={{
                  __html: newAfter,
                }}
              />
            </Alert>
          </React.Fragment>
        </div>
      );
    }
  }

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={12}>
          {quickPayShow ? (
            <>
              <Divider className={classes.dividerColor} />
              <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.pdY5}
              >
                <Grid item xs={6}>
                  <EQuickPay />
                </Grid>
                <Grid item xs="auto">
                  <FormControl component="fieldset">
                    <FormGroup aria-label="position" row>
                        <FormControlLabel
                          className={classes.zeroMargin}
                          value= {registerLR ? registerLabel("E_LANGUAGE_TOGGLE_BANGLA") : <Skeleton />}
                          control={<Switch color="primary" value={i18next.language} checked={i18next.language === 'bn'}  className={classes.toggle} onChange={switchHandler} />}
                          label= {registerLR ? registerLabel("E_LANGUAGE_TOGGLE_BANGLA") : <Skeleton />}
                        />
                    </FormGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <Divider className={classes.dividerColor} />
            </>
          ) : null}
        </Grid>
        <Grid item xs={12}>
          {loginShow ? (
            <React.Fragment>
              <Grid
                container
                direction="column"
                spacing={1}
                className={classes.marginContain}
              >
                <Grid item xs={12}>
                {
                  loginLabelReady ?
                  <Typography variant="h5" className={classes.loginLabel}>
                    {loginLabels("E_AUTH_LOGIN_TITLE")}
                  </Typography>
                  :<Skeleton />
                }
                </Grid>
                <Grid item xs={12} className={classes.inpField}>
                  <Grid container >
                    <Grid item xs={12} className={[classes.alignuserName, classes.zeroMargin]}>
                      <Typography variant="caption">
                     {/* {loginLabels("CN_UN")} */}
                        <FormControl component="fieldset">
                          <RadioGroup
                            aria-label="gender"
                            row
                            name="userNameType"
                            value={userNameType}
                            onChange={handleChange}
                          >
                            <FormControlLabel
                              value={CUSTOMER_RADIO}
                              control={<Radio className={[classes.secondaryColor]} />}
                              label={<Typography variant="caption">
                                {loginLabelReady ? loginLabels("E_CN_TEXT") : ''}
                              </Typography>}
                              className={[classes.radioLabel, classes.mobileRadio]}
                              style={{lineHeight: '0'}}
                            />
                            <FormControlLabel
                              value={MOBILE_RADIO}
                              control={<Radio className={[classes.secondaryColor]} />}
                              label={<Typography variant="caption">
                                {loginLabelReady ? loginLabels("E_MOBILE_TEXT") : ''}
                              </Typography>}
                              className={classes.radioLabel}
                              style={{lineHeight: '0'}}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Typography>
                    </Grid>
                    {/* {
                      userNameType === MOBILE_RADIO && <Grid item xs={1}>
                        <CssTextField
                          value={0}
                          variant="standard"
                          autoComplete="off"
                          className={classes.mobileExt}
                          error={userNameError || userNameRequire}
                          InputProps={{
                            readOnly: true,
                          }}
                          style={{margin:'0 auto'}}
                        />
                      </Grid>
                    } */}
                    <Grid item xs={12} className={classes.mobileinpGrid}>
                      <CssTextField
                        // placeholder={loginLabelReady ? labels("NESCO_MOBILE_NUMBER_PLACEHOLDER") : ''}
                        fullWidth
                        autoComplete="off"
                        variant="standard"
                        name="userName"
                        type="number"
                        value={userNameType === MOBILE_RADIO ? mobile : customerNum}
                        onChange={handleChange}
                        onBlur={userNameType === MOBILE_RADIO ? mobileBlur : customerNumberBlur}
                        onKeyPress={keypress}
                        inputProps={
                          userNameType === MOBILE_RADIO ? {
                            maxLength: mobileLength,
                          } : {}
                        }
                        InputProps={{
                          startAdornment:userNameType == MOBILE_RADIO ? <InputAdornment position="start">{country_Calling_Code_backend}</InputAdornment>:null
                        }}
                        // className={userNameType === MOBILE_RADIO ? classes.mobileInpField : ""}
                        error={userNameType === MOBILE_RADIO ? (mobileError || mobileRequire) : (emailError || emailRequire)}
                      />
                    </Grid>
                    <Typography className={classes.mobileNumberError}>
                      {
                        userNameType === MOBILE_RADIO ? (
                          mobileError ? (
                            loginLabelReady ? loginLabels("E_AUTH_LOGIN_EMAIL_ERROR") : ''
                          ) : mobileRequire ? (
                            loginLabelReady ? loginLabels("E_AUTH_LOGIN_MOBILE_REQUIRE") : ''
                          ) : (
                            <span className={classes.errorSpace}>&nbsp;</span>
                          )
                        ) : (
                          cNoError ? (
                            loginLabelReady ? loginLabels("E_AUTH_LOGIN_MOBILE_ERROR") : ''
                          ) : cNoRequire ? (
                            loginLabelReady ? loginLabels("E_AUTH_LOGIN_EMAIL_REQUIRE") : ''
                          ) : (
                            <span className={classes.errorSpace}>&nbsp;</span>
                          )
                        )
                      }
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12} className={classes.alignuserName}>
                    {
                      loginLabelReady ?
                      <Typography
                        variant="caption"
                        align="left"
                        className={classes.textColor}
                      >
                        {loginLabels("E_AUTH_LOGIN_PASSWORD")}
                      </Typography>
                      : <Skeleton />
                    }
                    </Grid>
                    <Grid item xs={12}>
                      <CssTextField
                      ref={ref}
                        type={showPassword ? "text" : "password"}
                        autoComplete="off"
                        variant="standard"
                        value={password}
                        name="password"
                        onPaste={pasteHandler}
                        onBlur={passwordBlur}
                        onKeyPress={keypress}
                        onChange={handleChange}
                        className={classes.inpField}
                        error={passwordRequire}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment className={classes.iconstyle} position="end">
                              
                      <IconButton 
                          className={classes.passwordEyeIcon}
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                                  {
                                  showPassword ? (
                                    <Visibility className={classes.iconstyle}/>
                                  ) : (
                                    <VisibilityOff className={classes.iconstyle}/>
                                  )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        helperText={
                          passwordRequire === true ? (
                            loginLabelReady ? loginLabels("E_AUTH_LOGIN_PASSWORD_REQUIRE") : ""
                          ) : loginError ? null : (
                            <span className={classes.errorSpace} />
                          )
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {loginError ? (
                  countdownerror ? (
                    <Grid item xs={12} className={classes.pd3}>
                      <Countdown date={timeCountdown} renderer={countDown} />
                    </Grid>
                  ) : (
                    <Grid item xs={12} className={classes.pd3}>
                      <Alert
                        className={classes.alertMessage}
                        severity="error"
                        icon={false}
                      >
                       { loginLabelReady ? loginLabels(loginErrorMessage):""}
                      </Alert>
                    </Grid>
                  )
                ) : null}
                <Button
                  className={classes.forgotPasswordBtn}
                  onClick={forgotPasswordClick}
                >
                  {forgotPwdLR ? forgotPasswordLabel("E_AUTH_FORGOT_PASSWORD") : <Skeleton />}
                </Button>
                <Grid item xs={12}>
                {}
                  <Button
                    variant="contained"
                    onClick={loginSubmit}
                    className={[classes.loginSubmitBtn, classes.cursor]}
                  >
                    {loginLabelReady ? loginLabels("E_AUTH_LOGIN_SUBMIT_BUTTON") : <Skeleton />}
                    &nbsp;
                    {isLoading ? (
                      <CircularProgress
                        size={18}
                        className={classes.circularProgressColor}
                      />
                    ) : (
                      " "
                    )}
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    className={classes.btnContainer}
                  >
                    {/* <Grid item xs={5} sm={8} className={classes.mr1}> */}
                      {/* <Button
                        variant="text"
                        onClick={loginOtpClick}
                        className={classes.otpBtn}
                      >
                        {loginOtpLR ? loginOtpLabel("E_AUTH_LOGIN_OTP") : <Skeleton />}
                      </Button> */}
                    {/* </Grid> */}
                    <Grid item xs={12}>
                      <Button
                        variant="text"
                        onClick={registerClick}
                        className={classes.registerBtn}
                      >
                        {registerLR ? registerLabel("E_AUTH_REGISTER_BUTTON") : <Skeleton />}
                      </Button>
                    </Grid>
                    <Grid item xs={12} className={classes.supportNumber} >
                    <Typography variant="body2">{registerLR ? registerLabel("E_SUPPORT_NUMBER") : <Skeleton />}</Typography><a style={{fontSize:'1rem'}} href={`tel:${supportNumber}`}>{supportNumber}</a>
                    </Grid>
                  </Grid>
                </Grid>
                {/* <Grid item xs={12}>
                  <Grid container justify="center" spacing={1}>
                    <Grid item xs="auto">
                      <NewConnection />
                    </Grid>
                    <Grid item xs="auto">
                      <TrackingNewConnection />
                    </Grid>
                  </Grid>
                </Grid> */}
              </Grid>
            </React.Fragment>
          ) : null}
        </Grid>
        <Grid item xs={12}>
          {registerShow ? (
            <React.Fragment>
              <Grid container direction="row">
                <EsignUpVerification handlecancel={showLogin} />
              </Grid>
            </React.Fragment>
          ) : null}

          {loginOtpShow ? (
            <React.Fragment>
              <ESendOtp />
            </React.Fragment>
          ) : null}
          {forgotPasswordShow ? (
            <React.Fragment>
              <EForgot_Password />
            </React.Fragment>
          ) : null}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
export default ELogin;
